import React, { useContext, useState } from 'react';
import { NotebookContext } from '../../context/NotebookContext';
import client from '../../lib/client';
import redirect from '../../lib/redirect';
import { deleteNoteMutation, notesQuery } from '../../queries/notes';
import {
  NoteDeleteMutation,
  NoteDeleteMutationVariables
} from '../../queries/__generated__/NoteDeleteMutation';
import { NotesQueryVariables } from '../../queries/__generated__/NotesQuery';
import { ToolBar } from '../pageElements';
import DatePill from '../Timeline/DatePill';
import TimelineEntry from '../Timeline/TimelineEntry';
import { Icon, ScrollView } from '../ui';
import Caption from './Caption';
import DataCard from './DataCard';
import MenuSmall from './MenuSmall';
import PrivateNote from './PrivateNote';
import { back } from '../../lib/helpers/navigate';

interface NoteReadOnlyProps {
  note: any;
  initalActiveTab: 'CAPTION' | 'DATA' | 'NOTE';
}

const NoteReadOnlyS: React.FC<NoteReadOnlyProps> = ({ note, initalActiveTab = 'DATA' }) => {
  const [activeTab, setActiveTab] = useState(initalActiveTab);

  const { notebook } = useContext(NotebookContext);

  function deleteNote() {
    const confirmDelete = confirm('Are you sure you want to delete this note?');

    if (confirmDelete) {
      return client
        .mutate<NoteDeleteMutation, NoteDeleteMutationVariables>({
          mutation: deleteNoteMutation,
          variables: { input: { id: note.id } },
          refetchQueries: [
            {
              query: notesQuery,
              variables: { input: { notebookId: notebook.id } } as NotesQueryVariables
            }
          ]
        })
        .then(data => {
          const { errors } = data;
          if (errors) {
            throw new Error(errors[0].message);
          }
          redirect('/notebook');
        });
    }

    return false;
  }

  return (
    <ScrollView className="pb5">
      <ToolBar className="justify-between" sticky={true}>
        <div className="ph3 pb1 bb b--light-gray w-100">
          <button onClick={() => back()}>
            <Icon name="close" />
          </button>
        </div>
      </ToolBar>

      <MenuSmall
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        note={note}
        deleteNote={deleteNote}
      />

      <div className="ph3 pt3">
        {activeTab === 'DATA' && <DataCard note={note} isEntryAuthor={false} />}
        {activeTab === 'CAPTION' && <Caption caption={note.context} />}
        {activeTab === 'NOTE' && <PrivateNote content={note.content} />}
      </div>
    </ScrollView>
  );
};

export default NoteReadOnlyS;
